export { UserEntity } from './user-entity';
export { UserEntityList } from './user.entity-list';

export type { Entity as UserEntityType } from './user-entity';
